import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'optInStatus',
  standalone: true
})
export class OptInStatusPipe implements PipeTransform {

  transform(dataItem: any): string {

    if (!dataItem?.hasoptin) {
      return "NO OPT-IN"; // No opt-in
    }

    const now = moment.utc();

    // nextEntryTime < now ENABLE button
    const nextOptInBeforeNow = moment.utc(dataItem?.nextoptin).isBefore(now);

    if (nextOptInBeforeNow && !dataItem?.isUsed) {
      // Promo
      if (dataItem?.type === 'Promo') {
        const isPromoActive = moment.utc(dataItem?.enddate).isSameOrAfter(now);
        return isPromoActive ? "showButton" : "UPCOMING";
      }

      // Giveaway: Now >= StartDate && Now <= EndDate
      const isGiveawayOpen =
        moment.utc(dataItem?.startdate).isSameOrBefore(now) &&
        moment.utc(dataItem?.enddate).isSameOrAfter(now);

      return isGiveawayOpen ? "showButton" : "UPCOMING";
    }

    // nextEntryTime > now disabled states
    if (moment.utc(dataItem?.nextoptin).isAfter(now) || dataItem?.isUsed) {
      return "USED"; // used
    }

    // Giveaway not open yet
    if (dataItem?.type === 'Giveaway' && moment.utc(dataItem?.startdate).isBefore(now)) {
      return "NOT OPEN"; // not open
    }

    return "UPCOMING"; // default disabled state
  }
}

